'use stric'
import remove from 'lodash/remove'

const ReportColors = ['#157FE1', '#E93E3E', '#18B32C', '#F1A80B', '#0D163A']

const getColor = (listChosen) => {
  let list = Object.assign([], ReportColors);

  // Поиск использованных цветов и их удаление из списка базовых цветов
  if (listChosen.length > 0) {
    ReportColors.map((item) => {
      if (listChosen.find(itemCar => itemCar.color === item))
        remove(list, function (color) {
          return color === item;
        })
        return null;
    })

    return list.length > 0 // Если свободные цвета остались в базовом списке, то
      ? list[0]  // отправляем первый из свободных,
      : null // иначе вызов функции для создания цветов, которых нет в базовом списке
  } else {
    return list[0]
  }

}

export {
  ReportColors,
  getColor
}